import { useMemo } from 'react';
import { AnnotationContextGroup, collectLeafAnnotations } from '../../contexts/AnnotationContext';
import { useAnnotationTree, useAnnotationLookup } from './useAnnotationContext';
import { useCustomSelector } from '../../redux/store';
import { Annotation } from '../../types/graphqlTypes';

// Filter out groups and return flat list of annotations

export const useFlatAnnotationList = () => {
  const { selectedAnnotations } = useCustomSelector((state) => state.rendererProvider, ['selectedAnnotations']);

  const annotations = useAnnotationTree();
  const annotationsByIdentifier = useAnnotationLookup();

  const allSelectedAnnotations = useMemo(() => {
    return selectedAnnotations.reduce((result: Annotation[], selectionItem) => {
      if (selectionItem.type === 'annotation') {
        const annotation = annotationsByIdentifier[selectionItem.identifier];
        if (annotation) {
          return [...result, annotation];
        }
      } else if (selectionItem.type === 'group') {
        const group = annotations.find((annotation) => annotation.identifier === selectionItem.identifier) as AnnotationContextGroup;
        if (group) {
          return [...result, ...collectLeafAnnotations(group)];
        }
      }
      return result;
    }, []);
  }, [annotations, annotationsByIdentifier, selectedAnnotations]);

  const allAnnotations = useMemo(() => {
    // filter out groups (including nested room folders)
    const result: Annotation[] = [];
    for (const item of annotations) collectLeafAnnotations(item, result);
    return result;
  }, [annotations]);

  return { allSelectedAnnotations, allAnnotations };
};
